import React from 'react';
import AppTooltip from '../../components/Tooltip/Tooltip';

interface DropdownSearchProps {
    id: string;
    label: string;
    placeholder: string;
    value: string;
    options: { id: string; name: string }[];
    onSearchChange: (value: string) => void;
    onOptionSelect: (id: string, name: string) => void;
    required?: boolean;
    tooltip?: string;
    disabled?: boolean;
}

const DropdownSearch: React.FC<DropdownSearchProps> = ({
    id,
    label,
    placeholder,
    value,
    options,
    onSearchChange,
    onOptionSelect,
    required = false,
    tooltip,
    disabled = false
}) => {
    return (
        <div>
            {label && (
                <label htmlFor={id} className="form-label">
                    {label} {required && <span className="text-danger">*</span>}
                </label>
            )}
            <div className="position-relative input-group">
                <input
                    type="text"
                    id={id}
                    name={id}
                    className="form-control"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onSearchChange(e.target.value)}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    autoComplete="off"
                    required={required}
                    disabled={disabled}
                />
                {tooltip && (
                    <AppTooltip
                        title={tooltip}
                        placement="bottom"
                    />
                )}
                <span
                    className="position-absolute top-50 end-0 translate-middle-y me-2"
                    style={{ pointerEvents: 'none' }}
                >
                    <i className="bi bi-caret-down-fill"></i>
                </span>
                <ul className="dropdown-menu w-100">
                    {options
                        .filter((option) =>
                            option.name && value
                                ? option.name.toLowerCase().includes(value.toLowerCase())
                                : true
                        )
                        .map((option) => (
                            <li key={option.id}>
                                <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() => onOptionSelect(option.id, option.name)}
                                >
                                    {option.name}
                                </button>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
};

export default DropdownSearch;